import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicStorageModule } from '@ionic/storage';
import { Network } from '@ionic-native/network';
import { SQLite } from '@ionic-native/sqlite';
import { Keyboard } from '@ionic-native/keyboard';

import { MyApp } from './app.component';
import { AcessoServiceProvider } from '../providers/acesso-service';
import { LoginServiceProvider } from '../providers/login-service';
import { GlobalServiceProvider } from '../providers/global-service';

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    Network,
    Keyboard,
    AcessoServiceProvider,
    LoginServiceProvider,
    GlobalServiceProvider,
    SQLite
  ]
})
export class AppModule { 
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts